import { render, staticRenderFns } from "./CourseSidebar.vue?vue&type=template&id=9aa366a4&"
import script from "./CourseSidebar.vue?vue&type=script&lang=ts&"
export * from "./CourseSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports